import React from 'react';

const services = [
  {
    title: 'Buy | Sell | Rent',
    desc: 'Discover verified properties and connect directly with trusted agents for smooth transactions.',
  },
  {
    title: 'Bank Auction Properties',
    desc: 'Access exclusive listings of foreclosed properties offered by banks at unbeatable prices.',
  },
  {
    title: 'Post Your Projects',
    desc: 'Builders and agents can showcase their latest residential or commercial projects to a wide audience.',
  },
  {
    title: 'Home Services',
    desc: 'Book professional help for plumbing, cleaning, electrical, and other household needs – all in one click.',
  },
  {
    title: 'Interior Design',
    desc: 'Transform your space with modern and elegant interior design solutions tailored to your taste.',
  },
  {
    title: 'Modular Kitchens',
    desc: 'Install stylish, space-saving modular kitchens designed for efficiency and aesthetic appeal.',
  },
  {
    title: 'Furniture Solutions',
    desc: 'Choose from curated furniture packages or custom solutions to furnish your property with ease.',
  },
  {
    title: 'Vastu Consultancy',
    desc: 'Get expert Vastu guidance to harmonize your home or office with positive energy flow.',
  },
  {
    title: 'Construction Companies',
    desc: 'Partner with trusted construction firms to bring your residential or commercial projects to life.',
  },
  {
    title: 'Movers & Packers',
    desc: 'Relocate effortlessly with professional moving and packing services for local or long-distance shifts.',
  },
  {
    title: 'Legal Assistance',
    desc: 'Consult experienced property lawyers to handle documentation, disputes, and legal formalities.',
  },
  {
    title: 'Tenant Verification',
    desc: 'Ensure safety with thorough background checks and police verification of prospective tenants.',
  },
  {
    title: 'Property Valuation',
    desc: 'Get accurate market-based valuation of your property from certified professionals.',
  },
];

const WhatWeOffer = () => (
  <section className="py-16 bg-gray-50">
    <div className="container mx-auto px-4">
      <h2
        className="text-3xl font-bold text-center mb-10"
        data-aos="fade-up"
        data-aos-duration="800"
      >
        What We Offer
      </h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
        {services.map((service, i) => (
          <div
            key={i}
            data-aos="fade-up"
            data-aos-duration="700"
            data-aos-delay={i * 100} // 👈 nice stagger effect
            className="bg-white p-6 rounded-lg shadow hover:shadow-md transition"
          >
            <h3 className="text-xl font-semibold mb-2">{service.title}</h3>
            {service.desc && <p className="text-gray-600">{service.desc}</p>}
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default WhatWeOffer;
